var _rect, _path, _circle, _circle2, _circle3, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertsMapAirplane(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 36,
    viewBox: "0 0 16 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0 9)",
    fill: "#F7F7F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 24.9998C7.38542 24.9998 6.89063 24.4961 6.89583 23.8758L6.89583 19.7507L1.00521 16.0021L1 14.5015L6.89063 16.3838L6.89062 12.2481L5.41667 11.1294L5.42187 10L7.99479 10.7529L10.5781 10L10.5885 11.1347L9.09375 12.264L9.09375 16.3679L15 14.5015L14.9948 16.0021L9.10417 19.7507L9.10417 23.8758C9.11458 24.4802 8.59375 25.0104 8 24.9998Z",
    fill: "#6A6E85"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 30,
    r: 1,
    fill: "#6A6E85"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 35,
    r: 1,
    fill: "#6A6E85"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 1,
    r: 1,
    fill: "#6A6E85"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 6,
    r: 1,
    fill: "#6A6E85"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsMapAirplane);
export default __webpack_public_path__ + "static/media/alerts_map_airplane.78938d758e7e257bcc41ccf231392794.svg";
export { ForwardRef as ReactComponent };